<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="600px"
    :persistent="true"
    content-class="elevated-dialog"
  >
    <v-card class="professional-confirm-dialog">
      <v-card-title  class="dialog-header gradient-bg" style="color: white; font-size: 16px;">
        {{ loading ? '正在删除…': '确认删除？' }}
      </v-card-title>

      <v-divider></v-divider>

      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <p class="subheading">{{ message }}</p>
      </v-card-text>

      <v-card-actions class="dialog-actions">
        <v-spacer/>
        <v-btn
            @click.native="visible = false"
            class="cancel-btn"
        >
          <v-icon left>close</v-icon>
          取消
        </v-btn>
        <v-btn
            color="primary"
            :disabled="loading"
            @click.native="onDelete"
            class="submit-btn"
        >
          <v-icon left>check</v-icon>
          确认
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    props: ['value', 'message', 'uri', 'dbid'],

    data() {
      return {
        loading: false
      }
    },

    computed: {
      visible: {
        // getter
        get: function () {
          return this.value;
        },
        // setter
        set: function (nv) {
          this.$emit('input', nv);
        }
      }
    },

    methods: {
      /**
       * **************************************************************
       * 异步数据请求
       */
      onDelete() {
        const vm = this;
        this.loading = true;
        this.axios.delete(`${this.uri}/${this.dbid}`)
          .then(rsp => {
            // 填充对话框
            vm.$emit('ok', rsp.data);
            vm.loading = false;
            this.visible = false;
          });
      }

    }
  }
</script>
<style scoped>
  div.card div.card__text {
    display: flex;
    font-size: 14px;
    margin: 4px auto;
    padding: 8px 15px;
    position: relative;
  }

  div.card div.card__text > div {
    -ms-flex-item-align: center;
    align-self: center;
    -webkit-box-flex: 1;
    -ms-flex: 1 1;
    flex: 1 1;
    margin-left: 1em;
  }

  /* 对话框整体样式 */
  .professional-confirm-dialog {
    border-radius: 12px !important;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15) !important;
  }

  /* 标题栏样式 */
  .dialog-header {
    padding: 20px 24px 12px !important;
    position: relative;
  }

  .gradient-bg {
    background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%);
  }

  .dialog-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.5px;
    display: block;
    width: 100%;
    margin-bottom: 12px;
  }

  .progress-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    margin: 0;
    width: 100%;
  }

  /* 内容区域样式 */
  .dialog-content {
    padding: 24px !important;
  }

  .message-text {
    font-size: 15px;
    color: #555;
    margin-bottom: 16px;
  }

  .note-textarea >>> .v-input__slot {
    border-radius: 8px !important;
    border-color: #e0e0e0 !important;
    transition: border-color 0.3s;
  }

  .note-textarea >>> .v-input__slot:hover {
    border-color: #bdbdbd !important;
  }

  .note-textarea >>> .v-input__slot:focus-within {
    border-color: #4a6cf7 !important;
    box-shadow: 0 0 0 2px rgba(74, 108, 247, 0.2);
  }

  /* 按钮样式 */
  .dialog-actions {
    padding: 16px 24px !important;
    border-top: 1px solid #f0f0f0;
  }

  .cancel-btn {
    color: #666 !important;
    min-width: 100px;
    height: 42px;
    border-radius: 6px;
    transition: all 0.3s;
  }

  .cancel-btn:hover {
    background: rgba(0, 0, 0, 0.05) !important;
    color: #333 !important;
  }

  .submit-btn {
    min-width: 120px;
    height: 42px;
    border-radius: 6px;
    background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%);
    box-shadow: 0 2px 6px rgba(74, 108, 247, 0.3);
    transition: all 0.3s;
  }

  .submit-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(74, 108, 247, 0.4);
  }

  .submit-btn.v-btn--disabled {
    background: #e0e0e0 !important;
    box-shadow: none !important;
  }
</style>
